import React from "react";

const PosIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.20107 21.0158H3.59082V8.67871C3.59082 7.52808 4.54558 6.5918 5.71891 6.5918H6.72804V7.19023H5.71891C4.88232 7.19023 4.20107 7.85776 4.20107 8.67871V21.0158Z"
        fill="currentColor"
      />
      <path
        d="M13.1321 21.3145H6.37109V20.716H13.1321C14.1784 20.716 15.0294 19.8815 15.0294 18.8554V9.05083C15.0294 8.02478 14.1784 7.19023 13.1321 7.19023H8.11806V6.5918H13.1321C14.5145 6.5918 15.6396 7.6951 15.6396 9.05083V18.856C15.6396 20.2117 14.5145 21.315 13.1321 21.315V21.3145Z"
        fill="currentColor"
      />
      <path
        d="M13.2285 12.7344H5.99316V8.75098H13.2285V12.7344ZM6.60341 12.136H12.6182V9.34941H6.60341V12.136Z"
        fill="currentColor"
      />
      <path
        d="M7.81712 14.8916H6.18555V15.49H7.81712V14.8916Z"
        fill="currentColor"
      />
      <path
        d="M10.5622 14.8916H8.93066V15.49H10.5622V14.8916Z"
        fill="currentColor"
      />
      <path
        d="M13.3083 14.8916H11.6768V15.49H13.3083V14.8916Z"
        fill="currentColor"
      />
      <path
        d="M7.81615 17.502H6.18457V18.1004H7.81615V17.502Z"
        fill="currentColor"
      />
      <path
        d="M10.5622 17.502H8.93066V18.1004H10.5622V17.502Z"
        fill="currentColor"
      />
      <path
        d="M13.3083 17.502H11.6768V18.1004H13.3083V17.502Z"
        fill="currentColor"
      />
      <path
        d="M12.4491 4.42969H11.8389V6.89308H12.4491V4.42969Z"
        fill="currentColor"
      />
      <path
        d="M7.0331 5.91855H6.42285V4.11997C6.42285 3.30391 7.10022 2.63965 7.93238 2.63965H13.3536V3.23809H7.93238C7.43641 3.23809 7.0331 3.6336 7.0331 4.11997V5.91855Z"
        fill="currentColor"
      />
      <path
        d="M14.8685 5.61062H11.8389V3.9301C11.8389 3.2185 12.4291 2.63965 13.1548 2.63965H13.5525C14.2782 2.63965 14.8685 3.2185 14.8685 3.9301V5.61062ZM12.4491 5.01218H14.2582V3.9301C14.2582 3.54873 13.9414 3.23809 13.5525 3.23809H13.1548C12.7659 3.23809 12.4491 3.54873 12.4491 3.9301V5.01218Z"
        fill="currentColor"
      />
      <path
        d="M20.3373 19.9844H17.3277V9.35234H15.335V8.75391H18.3429C19.4425 8.75391 20.3373 9.63143 20.3373 10.7097V19.9844ZM17.9379 19.386H19.7271V10.7097C19.7271 9.96112 19.1063 9.35234 18.3429 9.35234H17.9379V19.3865V19.386Z"
        fill="currentColor"
      />
      <path
        d="M17.6322 19.3857H16.4189V19.9842H17.6322V19.3857Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PosIcon;
